import React, { FC } from 'react'
import { useWatch } from 'react-hook-form'
import { ControlledTextField } from 'transfix-form/components'
import { Box, makeStyles } from 'transfix-ui/core'
import { FormModal } from 'transfix-ui'
import { TSaveRuleAsSchema, useSaveRuleAsForm } from './SaveRuleAsForm'

export interface ISaveRuleAsModal {
  name: string
  onClose: () => void
  onSave: (name: string) => void
  disabled: boolean
  error: string | undefined
}

const useStyles = makeStyles(() => ({
  form: {},
}))

export const SaveRuleAsModal: FC<ISaveRuleAsModal> = ({
  disabled,
  error,
  name,
  onClose,
  onSave,
}) => {
  const classes = useStyles()
  const { control, handleSubmit } = useSaveRuleAsForm({
    defaultValues: {
      name,
    },
  })

  const currentName = useWatch({
    name: 'name',
    control,
  })

  const handleContinue = (formData: TSaveRuleAsSchema) => {
    onSave(formData.name)
  }

  return (
    <FormModal
      size={4}
      open
      error={error}
      onClose={onClose}
      title='Save Rule As...'
      actions={[
        {
          label: 'Cancel',
          type: 'dismiss',
          action: onClose,
        },
        {
          label: 'Save',
          type: 'confirm',
          action: handleSubmit(handleContinue),
          disabled: !currentName || disabled,
        },
      ]}>
      <Box mb={3} className={classes.form}>
        <ControlledTextField
          name='name'
          control={control}
          TextInputProps={{
            label: 'Name Rule',
            dataTest: 'name-rule',
            required: true,
          }}
        />
      </Box>
    </FormModal>
  )
}
